import * as RadixSelect from '@radix-ui/react-select';
import { ChevronDown, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Select = RadixSelect.Root;
export const SelectValue = RadixSelect.Value;

export function SelectTrigger({ className, children, ...props }: RadixSelect.SelectTriggerProps) {
  return (
    <RadixSelect.Trigger
      className={cn(
        'flex h-8 w-full items-center justify-between rounded-sm border border-border bg-bg-surface px-3 py-1 text-sm text-text-primary placeholder:text-text-muted transition-colors focus:outline-none focus:border-accent disabled:cursor-not-allowed disabled:opacity-50 data-[placeholder]:text-text-muted',
        className,
      )}
      {...props}
    >
      {children}
      <RadixSelect.Icon>
        <ChevronDown className="h-3.5 w-3.5 text-text-muted" />
      </RadixSelect.Icon>
    </RadixSelect.Trigger>
  );
}

export function SelectContent({ className, children, ...props }: RadixSelect.SelectContentProps) {
  return (
    <RadixSelect.Portal>
      <RadixSelect.Content
        className={cn(
          'z-50 min-w-[8rem] overflow-hidden rounded border border-border bg-bg-surface shadow-lift',
          className,
        )}
        position="popper"
        sideOffset={3}
        {...props}
      >
        <RadixSelect.Viewport className="p-1">{children}</RadixSelect.Viewport>
      </RadixSelect.Content>
    </RadixSelect.Portal>
  );
}

export function SelectItem({ className, children, ...props }: RadixSelect.SelectItemProps) {
  return (
    <RadixSelect.Item
      className={cn(
        'relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm text-text-primary outline-none transition-colors hover:bg-bg-elevated focus:bg-bg-elevated data-[state=checked]:text-accent',
        className,
      )}
      {...props}
    >
      <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
        <RadixSelect.ItemIndicator>
          <Check className="h-3.5 w-3.5" />
        </RadixSelect.ItemIndicator>
      </span>
      <RadixSelect.ItemText className="pl-5">{children}</RadixSelect.ItemText>
    </RadixSelect.Item>
  );
}
